export const REFUND_REJECT = -1; // 审核拒绝
export const REFUND_CANCEL = -2; // 取消退款
export const REFUND_WAIT_CHECK = 0; // 待审核
export const REFUND_CHECK_PASS = 1; // 审核通过
export const REFUND_USER_SEND = 2; // 用户已发货
export const REFUND_SELLER_RECEIVE = 3; // 卖家已收货
export const REFUND_SELLER_SEND = 4; // 卖家已发货
export const REFUND_SUCCESS = 5; // 完成退款


export const APPLY_RETURN_MONEY = 0; // 仅退款
export const APPLY_RETURN_GOODS = 1; // 退款退货
export const APPLY_EXCHANGE_GOODS = 2; // 换货
export const REFUND_OPTION = [ // 没发货情况下 退款需要选择的原因
  { value: 1, title: '拍错／拍多／不想要' },
  { value: 2, title: '操作有误（商品、地址等选错）' },
  { value: 3, title: '未按约定时间发货' },
  { value: 4, title: '其他' }];

